<template lang="html">
  <Modal :header="false" :footer="false" id="logout" title="Unibit" color="black">
    <div slot="body">
      <div class="mt-4 mx-3">
        <h5>Do you want to save your changes and leave?</h5>
      </div>
      <div class="btns text-right">
        <button type="button" class="btn btn-secondary" @click="toLogout()">Yes, Log out</button>
        <button type="button" class="btn btn-info" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/base/modal";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  props: {
    defaultShow: {
      type: Boolean
    }
  },
  components: {
    Modal
  },
  methods: {
    toLogout() {
      this.$store.dispatch("logout");
      this.$notify({
        group: "note",
        title: "UniBit Account",
        text: "Successfully logged out",
        type: "success"
      });
      $("#logout").modal("hide");
      this.$router.replace("/signin");
    },
    ...mapMutations(["logout"])
  }
};
</script>

<style lang="css" scoped>
#logout {
  margin-top: 150px;
}

.btns {
  margin-top: 25px;
}

.btn {
  width: 25%;
}

.modal-body {
  background-color: #31353d;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/log-out.vue